export const SERVICE_STATUS = {
  scheduled: { label: "Scheduled", cls: "bg-sky-100 text-sky-800 border-sky-300" },
  in_progress: { label: "In Progress", cls: "bg-amber-100 text-amber-800 border-amber-300" },
  completed: { label: "Completed", cls: "bg-emerald-100 text-emerald-800 border-emerald-300" },
  cancelled: { label: "Cancelled", cls: "bg-zinc-200 text-zinc-600 border-zinc-400" },
};

export const ServiceStatusBadge = ({ status, testid }) => {
  const s = SERVICE_STATUS[status] || SERVICE_STATUS.scheduled;
  return <span data-testid={testid} className={`text-[10px] font-bold uppercase tracking-wider px-2 py-0.5 border whitespace-nowrap ${s.cls}`}>{s.label}</span>;
};

export const EVENT_TYPES = {
  service: { label: "Service jobs", dot: "bg-brand", chip: "bg-sky-50 text-sky-900 border-l-brand" },
  hire: { label: "Hire orders", dot: "bg-indigo-500", chip: "bg-indigo-50 text-indigo-900 border-l-indigo-500" },
  return: { label: "Hire returns", dot: "bg-orange-500", chip: "bg-orange-50 text-orange-900 border-l-orange-500" },
  due: { label: "Inspection / cert due", dot: "bg-red-500", chip: "bg-red-50 text-red-900 border-l-red-500" },
};

export const SERVICE_EDIT_ROLES = ["admin", "superadmin", "hire_manager", "hire_coordinator"];
